export const REPORT_ID = 'aquarium-crop-value';
export const REPORT_APE_ID = 'aquarium-crop-value-ape';
export const CUBE_ID = 'facts_slides';